import { StepProps } from '../IAppModels'
import defaultImage from '../../../../images/defaultImage.svg'
import React, { useRef, useState, useEffect } from 'react'
import { Col, Row, Stack } from 'react-bootstrap'
import { GETSIGNEDURLFORUPLOAD, VALIDATE_USER } from '../../../../../utils/GraphQLAPI'
import { useLazyQuery } from '@apollo/client'
import { BUCKET_NAME, getImageBaseUrl, BASE_URL } from '../../../../../utils/config'
import { Country, State } from 'country-state-city'
import { MenuComponent } from '../../../../../_metronic/assets/ts/components'
import clsx from 'clsx'
import Dropdown from '../../../../../app/sharedComponent/Dropdown/Dropdown'

const Step1 = ({
  data,
  updateData,
  hasError,
  setHasError,
  isDisabled,
  emailValidate,
  setEmailValidate,
  style,
  setNotes,
  notes,
  updatedData,
  refreshList,
  setImageURL,
  deleteCall,
  setDeleteCall,
  originalEmail
}: StepProps) => {
  const [image, setImage] = useState<File | null>()
  const [preview, setPreview] = useState<any>()
  const fileInputRef = useRef<any>()
  const [allStates, setAllStates] = useState<any>()
  const [country, setCountry] = useState<any>(
    data.clientInfo.country ? data.clientInfo.country : 'select country'
  )
  const [state, setState] = useState<any>({
    label: data.clientInfo.state || 'select state',
  })
  const [uploadFileName, setUploadFileName] = React.useState<any>('')
  // const [rerender, setRerender] = React.useState<any>(false)
  const [addressValidation, setAddressValidation] = useState<any>('')
  const [zipValidation, setZipValidation] = useState<any>('')
  const [nameValidation, setNameValidation] = useState<any>('')
  const [cityValidation, setCityValidation] = useState<any>('')

  const noteList = [
    { fieldName: 'note1', placeHolderText: 'Note 1', position: 1 },
    { fieldName: 'note2', placeHolderText: 'Note 2', position: 2 },
    { fieldName: 'note3', placeHolderText: 'Note 3', position: 3 },
  ]
  const [emailValidation] = useLazyQuery(VALIDATE_USER, {
    fetchPolicy: 'network-only',
    onCompleted: (value) => {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value.validateUser.users[0].emailId)) {
        setEmailValidate('Invalid email address')
      } else if (value.validateUser.users[0].emailId !== '') {
        if (value.validateUser.users[0].type === 'NOT_EXISTS') {
          setEmailValidate('')
        } else if (value.validateUser.users[0].type === 'EXISTS') {
          console.log("==data data", data)
          console.log("==data value", value)
          setEmailValidate('Email ID already exists!')
        } else {
          setEmailValidate('')
        }
      }
    },
  })

  const handleEmailValidation = (value: any) => {
    if (value === originalEmail) {
      setEmailValidate('')
      return
    }
    const variable = {
      users: [
        {
          emailId: value,
        },
      ],
    }
    emailValidation({
      variables: {
        validateUserInput: variable,
      },
    })
  }

  const handleAddressValidation = (addressValue: any) => {
    if (addressValue.length > 130) {
      setAddressValidation("Address shouldn't exceed 130 characters")
    } else {
      setAddressValidation('')
    }
  }

  const handleNameValidation = (nameValue: any) => {
    const nameVal = '[^0-9A-Za-z ,]'

    if (nameValue.length > 40) {
      setNameValidation("Client Name shouldn't exceed 40 characters")
    } else if (nameValue.match(nameVal)) {
      setNameValidation('Special characters are not allowed')
    } else {
      setNameValidation('')
    }
  }

  const handleZipCodeValidation = (zipValue: any) => {
    const zipVal = /^(?!0{5})([0-9]{5}(?:-[0-9]{4})?|[A-Z][0-9][A-Z])$/
    if (!zipValue.match(zipVal)) {
      setZipValidation('Enter a valid zip code')
    } else {
      setZipValidation('')
    }
  }

  const handleCityValidation = (cityValue: any) => {
    const nameVal = '[^0-9A-Za-z ,]'
    if (cityValue.match(nameVal)) {
      setCityValidation('Special characters are not allowed')
    } else {
      setCityValidation('')
    }
  }

  useEffect(() => {
    MenuComponent.reinitialization()
    const country: any = Country.getCountryByCode('US')
    selectCountry(country)
    const state = State.getStatesOfCountry('US')

    const formattedState = state.map((eachState) => ({
      id: eachState.isoCode,
      value: eachState.name,
    }))

    setAllStates(formattedState)

    const filteredResult = state.find((e) => e.name === data.clientInfo.state)

    if (filteredResult) {
      setState({
        label: filteredResult.name,
        value: filteredResult.isoCode,
      })
    }
    if (image) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setPreview(reader.result as string)
      }
      reader.readAsDataURL(image)
    }
  }, [])

  useEffect(() => {
    data.clientInfo.imageUrl
      ? setPreview(process.env.REACT_APP_IMAGE_BASE_URL + data.clientInfo.imageUrl)
      : setPreview(defaultImage)
    if (image) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setPreview(reader.result as string)
      }
      reader.readAsDataURL(image)
    }
  }, [data.clientInfo.imageUrl, image])

  const selectCountry = (country_value: any) => {
    setCountry(country_value.isoCode)
    const state = State.getStatesOfCountry(country_value.isoCode)
    updateData({
      clientInfo: {
        ...data.clientInfo,
        country: country_value.isoCode,
      },
    })
    const formattedState = state.map((eachState) => ({
      id: eachState.isoCode,
      value: eachState.name,
    }))
    setAllStates(formattedState)
  }

  const selectState = (state_value: any, fieldName: any) => {
    setState(state_value)
    updateData({
      clientInfo: {
        ...data.clientInfo,
        state: state_value.label,
      },
    })
  }

  const [getsignedUrlUpload, { loading: urlLoading, data: urlData }] =
    useLazyQuery(GETSIGNEDURLFORUPLOAD, {
      variables: { key: uploadFileName, bucketName: BUCKET_NAME },
    })

  const inputStyle = {}

  const handleUploadImage = async (event: React.ChangeEvent<any>) => {
    const file = event.target.files[0]
    const allowed_image_type = ['image/png', 'image/jpg', 'image/jpeg']
    if (!allowed_image_type.includes(file.type)) {
      return
    }
    // checking for image types
    if (file && file.type.substr(0, 5) === 'image') {
      const imagesformat = file.name.replace(/\s+/g, '-')
      setUploadFileName(`images/${imagesformat.split('.').join('-' + Date.now() + '.')}`)
      setImage(file)
    } else {
      setImage(null)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fileUploadToS3 = (objectUrl: any) => {
    if (objectUrl) {
      fetch(objectUrl, {
        method: 'PUT',
        headers: { 'Content-Type': 'image/*' },
        body: image,
      }).then((response) => {
        if (response && response.url) {
          const bucketUrl = response.url.split('?')[0]
          let imagePath = getImageBaseUrl()
          imagePath += bucketUrl.split('com')[1]
          // setImageURL(imagePath)
          updateData({
            clientInfo: {
              ...data.clientInfo,
              imageUrl: bucketUrl.split('com/')[1],
            },
          })
        }
      })
    }
  }

  useEffect(() => {
    if (!urlLoading && uploadFileName.length > 0) {
      if (urlData) {
        setUploadFileName('')
        fileUploadToS3(urlData.getSignedUrlForUpload.preSignedUrl)
        setDeleteCall(false)
      } else {
        uploadFileName && getsignedUrlUpload()
      }
    }
  }, [fileUploadToS3, uploadFileName])

  const handleNotesChange = (value: any, position: any) => {
    setNotes((prev: any) => {
      return prev.map((note: any) => {
        if (note.position === position) {
          return {
            ...note,
            description: value,
          }
        }
        return note
      })
    })
  }

  const deleteS3Object = async () => {
    setPreview(defaultImage)
    setImageURL && setImageURL('')
    setDeleteCall(true)
  }
  // useEffect(()=>{
  //   if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.clientInfo.clientAdmin.clientEmail)){
  //     setEmailValidation("Invalid email address")
  //   }
  // },[data.clientInfo.clientAdmin.clientEmail])
  console.log(data.clientInfo.state, ">>>>>>>>>.......", state.label)
  return (
    <div className='current' data-kt-stepper-element='content'>
      <div
        className='w-100'
        style={{ height: '435px', overflowX: 'hidden', overflowY: 'auto', paddingRight: '10px' }}
      >
        <div className='fv-row'>
          <label className='d-flex align-items-center fw-bold mb-4'>
            <span
              className='fs-3'
              style={{
                fontSize: '20px',
                fontWeight: '700',
                color: '#3F4254',
                letterSpacing: '-0.01em',
                lineHeight: '32px',
              }}
            >
              Client Information
            </span>
          </label>
        </div>
        <div>
          <div>
            {!urlLoading ? (
              <Stack direction='horizontal' gap={1}>
                <div style={{ position: 'relative' }}>
                  {preview ? (
                    <>
                      <img
                        src={preview}
                        alt='preview'
                        width='128'
                        height='128'
                        style={{ objectFit: 'contain' }}
                        onClick={(event) => {
                          event.preventDefault()
                          fileInputRef.current.click()
                        }}
                      />
                      {data?.clientInfo?.imageUrl !== '' &&
                        Boolean(data?.clientInfo?.imageUrl) &&
                        preview !== '' &&
                        deleteCall === false && (
                          <label
                            onClick={() => deleteS3Object()}
                            className={`btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow`}
                            data-kt-image-input-action='change'
                            data-bs-toggle='tooltip'
                            aria-label='Change avatar'
                            data-bs-original-title='Change avatar'
                            data-kt-initialized='1'
                            style={{ position: 'absolute', top: '-10px', right: '-12px' }}
                          >
                            <svg
                              width='12'
                              height='12'
                              viewBox='0 0 20 20'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <g clip-path='url(#clip0_22658_81815)'>
                                <path
                                  opacity='0.5'
                                  d='M10 8.23254L8.2326 9.99997L0.36628 17.8655C-0.122021 18.3538 -0.122021 19.1455 0.36628 19.6338C0.854542 20.1221 1.64623 20.1221 2.13453 19.6338L10 11.7674L11.7675 9.99997L19.6338 2.13447C20.1221 1.64621 20.122 0.854526 19.6338 0.366225C19.1455 -0.122075 18.3538 -0.122075 17.8655 0.366225L10 8.23254Z'
                                  fill='currentColor'
                                />
                                <path
                                  d='M9.99997 8.23254L11.7674 9.99997L19.6337 17.8655C20.122 18.3538 20.122 19.1455 19.6337 19.6338C19.1455 20.1221 18.3538 20.1221 17.8655 19.6338L9.99997 11.7674L8.23254 9.99997L0.366225 2.13447C-0.122075 1.64621 -0.122036 0.854526 0.366225 0.366225C0.854487 -0.122075 1.64617 -0.122075 2.13447 0.366225L9.99997 8.23254Z'
                                  fill='currentColor'
                                />
                              </g>
                              <defs>
                                <clipPath id='clip0_22658_81815'>
                                  <rect width='20' height='20' fill='currentColor' />
                                </clipPath>
                              </defs>
                            </svg>
                          </label>
                        )}
                    </>
                  ) : (
                    <img
                      src={defaultImage}
                      alt='default img'
                      width='128'
                      height='128'
                      style={{ objectFit: 'contain' }}
                      onClick={(event) => {
                        event.preventDefault()
                        fileInputRef.current.click()
                      }}
                    />
                  )}

                  <input
                    type='file'
                    className='d-none'
                    ref={fileInputRef}
                    accept='image/png,image/jpg,image/jpeg'
                    onChange={(event: any) => handleUploadImage(event)}
                  />
                </div>
                <div>
                  <span className='fs-6 text-grey-400 text-muted'>
                    Allowed file types:
                    <br />
                    png,jpg,jpeg.
                  </span>
                </div>
              </Stack>
            ) : (
              <>
                <input
                  type='image'
                  src={preview}
                  alt='preview'
                  width='128'
                  height='128'
                  disabled={true}
                  className='imageBlur'
                />
                <span className='indicator-progress img-spinner' style={{ display: 'block' }}>
                  Uploading...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              </>
            )}
          </div>
          {/* {
            imageError &&
            <div className='fv-row'>
                <div className='text-danger'>
                  {imageError}
                </div>
              </div>
          } */}
          {/*begin::Form Group */}
          <div className='fv-row mb-2'>
            <label className='d-flex align-items-center  mb-2'>
              <span className='fs-6 fw-semibold lh-23'>
                Client Name <span className='h5 text-danger'>*</span>
              </span>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              name='client name'
              placeholder='Enter client name'
              style={inputStyle}
              value={data.clientInfo.clientName}
              maxLength={41}
              onChange={(e) => (
                updateData({
                  clientInfo: {
                    ...data.clientInfo,
                    clientName: e.target.value,
                  },
                }),
                handleNameValidation(e.target.value)
              )}
            />

            <div className='fv-plugins-message-container' style={{ position: style.positionStyle }}>
              {!data.clientInfo.clientName && hasError ? (
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  Client Name is required
                </div>
              ) : (
                <div
                  data-field='appname'
                  data-validator='notEmpty'
                  className='fv-help-block'
                  style={{ visibility: 'hidden' }}
                >
                  Client Name is required
                </div>
              )}
            </div>

            <div className='fv-plugins-message-container' style={{ position: style.positionStyle }}>
              {data.clientInfo.clientName && nameValidation ? (
                <div
                  data-field='appname'
                  data-validator='notEmpty'
                  className='fv-help-block'
                  style={{ marginTop: '-15px' }}
                >
                  {nameValidation}
                </div>
              ) : (
                <div
                  data-field='appname'
                  data-validator='notEmpty'
                  className='fv-help-block'
                  style={{ visibility: 'hidden' }}
                >
                  {nameValidation}
                </div>
              )}
            </div>
          </div>
          {/*end::Form Group

          {/*begin::Form Group2 */}
          <div className='fv-row mb-2'>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23'>
                Client Email ID <span className='h5 text-danger'>*</span>
              </span>
            </label>
            <input
              type='email'
              // className='form-control form-control-lg form-control-solid'
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid':
                    (emailValidate && emailValidate === 'EXISTS') ||
                    emailValidate === 'Invalid email address',
                },
                {
                  'is-valid': emailValidate && emailValidate === 'NOT_EXISTS',
                }
              )}
              name='client location'
              placeholder='Enter email id'
              // disabled={isDisabled}
              value={data.clientInfo?.clientAdmin?.clientEmail}
              style={inputStyle}
              onChange={
                (e) =>
                  updateData({
                    clientInfo: {
                      ...data.clientInfo,
                      clientAdmin: {
                        clientEmail: e.target.value,
                      },
                    },
                  })
                // handleEmailValidation(e.target.value)
              }
              onBlur={(e) => handleEmailValidation(e.target.value)}
            />

            <div className='fv-plugins-message-container' style={{ position: style.positionStyle }}>
              {!data.clientInfo?.clientAdmin?.clientEmail && hasError && (
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  Email ID is required
                </div>
              )}
            </div>

            <div className='fv-plugins-message-container' style={{ position: style.positionStyle }}>
              {data.clientInfo?.clientAdmin?.clientEmail && emailValidate && (
                <div
                  data-field='appname'
                  data-validator='notEmpty'
                  className='fv-help-block'
                >
                  {emailValidate}
                </div>
              )}
            </div>
          </div>
          {/*end::Form Group2 */}

          {/*begin::Form Group2 */}
          <div className='fv-row mb-3'>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23'>
                Address <span className='h5 text-danger'>*</span>
              </span>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              name='client location'
              style={inputStyle}
              placeholder='Enter Unit, Suite, Floor, Building, etc.'
              value={data.clientInfo.clientAddress}
              maxLength={131}
              onChange={(e) => (
                updateData({
                  clientInfo: {
                    ...data.clientInfo,
                    clientAddress: e.target.value,
                  },
                }),
                handleAddressValidation(e.target.value)
              )}
            />

            <div className='fv-plugins-message-container' style={{ position: style.positionStyle }}>
              {!data.clientInfo.clientAddress && hasError ? (
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  Client Address is required
                </div>
              ) : (
                <div
                  data-field='appname'
                  data-validator='notEmpty'
                  className='fv-help-block'
                  style={{ display: 'none' }}
                >
                  Client Address is required
                </div>
              )}
            </div>

            <div className='fv-plugins-message-container' style={{ position: style.positionStyle }}>
              {data.clientInfo.clientAddress && addressValidation ? (
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {addressValidation}
                </div>
              ) : (
                <div
                  data-field='appname'
                  data-validator='notEmpty'
                  className='fv-help-block'
                  style={{ visibility: 'hidden' }}
                >
                  {addressValidation}
                </div>
              )}
            </div>
          </div>
          {/*end::Form Group2 */}
          {/*begin::Form Group */}
          <Row className='d-flex align-items-start mt-3'>
            <Col className='dropdown-style' sm={6} md={6}>
              <label htmlFor='country' style={{ marginBottom: '4px' }}>
                <span className='fs-6 fw-semibold lh-23'>Country</span>
              </label>
              <a
                href='#'
                className='btn btn-lignt btn-sm form-solid bg-light d-flex align-items-center justify-content-between w-170px'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                style={{
                  borderRadius: '6px',
                  height: '43px',
                  // width: '220px',
                }}
              >
                {country}
                {/* <img src={Arrow} alt='' width='22px' height='22px' /> */}
              </a>

              <div className='fv-plugins-message-container' style={{ position: style.positionStyle }}>
                {!data.clientInfo.country && hasError ? (
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    Country is required
                  </div>
                ) : (
                  <div
                    data-field='appname'
                    data-validator='notEmpty'
                    className='fv-help-block'
                    style={{ visibility: 'hidden' }}
                  >
                    Country is required
                  </div>
                )}
              </div>
              {/* begin::Menu */}
            </Col>
            <Col className='dropdown-style' sm={6} md={6}>
              <label htmlFor='country' style={{ marginBottom: '4px' }}>
                <span className='fs-6 fw-semibold lh-23'>
                  State <span className='h5 text-danger'>*</span>
                </span>
              </label>
              <Dropdown
                fieldName="State"
                optionList={allStates}
                handleSelectedItem={selectState}
                selectedVal={state?.label}
                data={data.clientInfo.state}
                hasError={hasError}
              />
            </Col>
          </Row>
          {/*begin::Form Group */}
          <Row className='d-flex align-items-start mt-3'>
            <Col className='dropdown-style' sm={6} md={6}>
              <label htmlFor='country' style={{ marginBottom: '4px' }}>
                <span className='fs-6 fw-semibold lh-23'>
                  City <span className='h5 text-danger'>*</span>
                </span>
              </label>

              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='city name'
                placeholder='Enter city name'
                style={inputStyle}
                value={data.clientInfo.city}
                onChange={(e) => (
                  updateData({
                    clientInfo: {
                      ...data.clientInfo,
                      city: e.target.value,
                    },
                  }),
                  handleCityValidation(e.target.value)
                )}
              // onBlur={(e)=>handleCityValidation(e.target.value)}
              />

              <div className='fv-plugins-message-container' style={{ position: style.positionStyle }}>
                {!data.clientInfo.city && hasError ? (
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    City is required
                  </div>
                ) : (
                  <div
                    data-field='appname'
                    data-validator='notEmpty'
                    className='fv-help-block'
                    style={{ visibility: 'hidden' }}
                  >
                    City is required
                  </div>
                )}
              </div>

              <div className='fv-plugins-message-container' style={{ position: style.positionStyle }}>
                {data.clientInfo.city && cityValidation ? (
                  <div
                    data-field='appname'
                    data-validator='notEmpty'
                    className='fv-help-block'
                    style={{ marginTop: '-15px' }}
                  >
                    {cityValidation}
                  </div>
                ) : (
                  <div
                    data-field='appname'
                    data-validator='notEmpty'
                    className='fv-help-block'
                    style={{ visibility: 'hidden' }}
                  >
                    {cityValidation}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={6} md={6} className='position-relative'>
              <label htmlFor='country' style={{ marginBottom: '4px' }}>
                <span className='fs-6 fw-semibold lh-23'>
                  Zip Code <span className='h5 text-danger'>*</span>
                </span>
              </label>
              <input
                type='text'
                maxLength={5}
                className='form-control form-control-lg form-control-solid'
                name='Enter zipcode'
                style={inputStyle}
                value={data.clientInfo.zipcode}
                onChange={(e) => (
                  updateData({
                    clientInfo: {
                      ...data.clientInfo,
                      zipcode: e.target.value,
                    },
                  }),
                  handleZipCodeValidation(e.target.value)
                )}
                placeholder='Enter zip code'
                required
              />

              <div className='fv-plugins-message-container' style={{ position: style.positionStyle }}>
                {data.clientInfo.zipcode && zipValidation ? (
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {zipValidation}
                  </div>
                ) : (
                  <div
                    data-field='appname'
                    data-validator='notEmpty'
                    className='fv-help-block'
                    style={{ display: 'none' }}
                  >
                    {zipValidation}
                  </div>
                )}
              </div>

              <div className='fv-plugins-message-container' style={{ marginTop: '0px' }}>
                {!data.clientInfo.zipcode && hasError ? (
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    Zip Code is required
                  </div>
                ) : (
                  <div
                    data-field='appname'
                    data-validator='notEmpty'
                    className='fv-help-block'
                    style={{ visibility: 'hidden' }}
                  >
                    Zip Code is required
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <div className='fv-row mb-3'>
            <label className='d-flex align-items-center mb-2 required'>
              <span className='fs-6 fw-semibold lh-23'>Client DUNS Number</span>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              name='Client Duns Number'
              style={inputStyle}
              placeholder='Enter Client DUNS Number'
              value={data.clientInfo.clientDuns}
              onChange={(e) => {
                updateData({
                  clientInfo: {
                    ...data.clientInfo,
                    clientDuns: e.target.value,
                  },
                })
              }}
            />

            <div className='fv-plugins-message-container' style={{ position: style.positionStyle }}>
              {!data.clientInfo.clientDuns && hasError && (
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  Client DUNS number is required
                </div>
              )}
            </div>
          </div>

          <Stack direction='horizontal' className='mt-5' gap={5}>
            <div className='form-check align-items-start form-check-custom form-check-solid sm-6'>
              <input
                className='form-check-input me-2'
                type='radio'
                id='generate'
                name='uan'
                checked={!data.clientInfo.isCopyUan}
                onChange={() =>
                  updateData({
                    clientInfo: {
                      ...data.clientInfo,
                      isCopyUan: false,
                    },
                  })
                }
              />
              <label className='form-check-label' htmlFor='generate'>
                <div className='fs-5'>Generate random Account Number</div>
                {/* Generate random customer DUNS number  */}
              </label>
            </div>

            <div className='form-check align-items-start  form-check-custom form-check-solid'>
              <input
                className='form-check-input me-2'
                type='radio'
                id='copy'
                name='uan'
                checked={data.clientInfo.isCopyUan}
                onChange={() => {
                  updateData({
                    clientInfo: {
                      ...data.clientInfo,
                      isCopyUan: true,
                    },
                  })
                }}
              />
              <label className='form-check-label' htmlFor='copy'>
                <div className='fs-5'>Copy UAN</div>
              </label>
            </div>
          </Stack>

          <Stack direction='horizontal' className='mt-5' gap={5}>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientInfo.EDIRecordingSync}
                onChange={() => {
                  updateData({
                    clientInfo: {
                      ...data.clientInfo,
                      EDIRecordingSync: !data.clientInfo.EDIRecordingSync,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                EDI recording sync
              </label>
            </div>

            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientInfo.isEdiEnrollmentRequired}
                onChange={() => {
                  updateData({
                    clientInfo: {
                      ...data.clientInfo,
                      isEdiEnrollmentRequired: !data.clientInfo.isEdiEnrollmentRequired,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                EDI enrollment required
              </label>
            </div>
          </Stack>

          <div className='mt-4'>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23'>Additional Information</span>
            </label>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={12}>
                <Stack gap={4}>
                  {noteList.map((noteItem: any, index: number) => {
                    return (
                      <div key={noteItem.fieldName}>
                        <input
                          type='text'
                          id={noteItem.fieldName}
                          placeholder={noteItem.placeHolderText}
                          className='form-control form-control-solid'
                          value={
                            notes?.filter((note: any) => note?.position === noteItem.position)[0]
                              ?.description
                          }
                          onChange={(e) => {
                            handleNotesChange(e.target.value, noteItem.position)
                          }}
                        />
                      </div>
                    )
                  })}
                </Stack>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Step1 }